var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { round as precisionRound } from 'lodash';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTrainerQaAPI } from '../selectors';
import { CalculatorForm } from './calculatorForm';
import { TRAINER_INPUT, TRAINER_ROLE } from './constants';
import { useCalculatorRoleSync } from './useCalculatorRoleSync';
var calculateTrainerRatio = function (formData) {
    var trainingLength = formData.trainingLength || 1;
    var classSize = formData.classSize || 1;
    var supportStaffShrinkage = precisionRound(formData.shrinkage || 0, 1);
    var numberTrainer = Math.ceil((((formData.attrition * formData.numberReqAgent) / classSize) * trainingLength) /
        4 /
        (1 - supportStaffShrinkage * 0.01));
    var numberOfRequiredAgent = Math.round(formData.numberReqAgent);
    var trainerRatio = numberTrainer ? Math.ceil(numberOfRequiredAgent / numberTrainer) : null;
    return __assign(__assign({}, formData), { trainingLength: trainingLength, classSize: classSize, shrinkage: supportStaffShrinkage, numberTrainer: numberTrainer, numberReqAgent: numberOfRequiredAgent, trainerRatio: trainerRatio });
};
export var TrainerForm = function (_a) {
    var setValue = _a.setValue, watch = _a.watch;
    var trainerData = useTrainerQaAPI()[0];
    var _b = useForm(), control = _b.control, reset = _b.reset, handleSubmit = _b.handleSubmit;
    var _c = useCalculatorRoleSync(TRAINER_ROLE, watch, setValue), isFTEBased = _c.isFTEBased, selectedLocationId = _c.selectedLocationId, setSelectedLocationId = _c.setSelectedLocationId, applyRatioToRoles = _c.applyRatioToRoles;
    useEffect(function () {
        if (trainerData.data) {
            var value = {
                attrition: trainerData.data.attrition,
                avgNewHire: Math.ceil(trainerData.data.attrition * (isFTEBased ? trainerData.data.agentsFte : trainerData.data.headcountFte)),
                numberReqAgent: isFTEBased ? trainerData.data.agentsFte : trainerData.data.headcountFte,
            };
            reset(value);
        }
    }, [isFTEBased, reset, trainerData.data]);
    var handleFormSubmit = handleSubmit(function (values) {
        var newValues = calculateTrainerRatio(values);
        reset(newValues);
        if (newValues.trainerRatio) {
            applyRatioToRoles(newValues.trainerRatio);
        }
    });
    return (_jsx(CalculatorForm, { data: TRAINER_INPUT, control: control, onSubmit: handleFormSubmit, selectedLocationId: selectedLocationId, onLocationChange: setSelectedLocationId }));
};
